/**
 * cortex-admin の Workspace 権限 API contract（zod schema + 型）。
 *
 * **検証規則はここに書き写さない。** 「どのパスを配れるか」「末尾の `/` が必要か」等の判定は
 * `@cortex/domain-workspace-permissions` が持つ正本で、API はそこが投げた文言をそのまま返す。
 * contract に規則を複製すると、正本を変えたときに画面側だけ古い条件で弾き続ける。
 * ここで固定するのは**形**（欄の有無と型）だけ。
 *
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business Share the workspace permission API shape between cortex-admin API and Web
 * @graph-connects none
 */
import { z } from 'zod';
/** ロール。読み手（git-server の ACL）と同じ 2 値。 @graph-connects none */
export const WorkspacePermissionRoleSchema = z.enum(['developer', 'viewer']);
/** 権限 1 件。 @graph-connects none */
export const WorkspacePermissionSchema = z.object({
    email: z.string(),
    allowedPaths: z.array(z.string()),
    allowedStacks: z.array(z.string()),
    gitAuthorName: z.string(),
    role: WorkspacePermissionRoleSchema,
    updatedBy: z.string().optional(),
    updatedAt: z.string().optional(),
});
/**
 * 一覧レスポンス。
 *
 * `bootstrapAdmins` はコードに固定された管理者（ロックアウト防止の床）で、画面では
 * 編集不可として見せる。`admins` は Firestore に保存されている編集可能なぶんだけ。
 * @graph-connects none
 */
export const WorkspacePermissionListSchema = z.object({
    permissions: z.array(WorkspacePermissionSchema),
    admins: z.array(z.string()),
    bootstrapAdmins: z.array(z.string()),
});
/** 権限の登録・更新リクエスト。 @graph-connects none */
export const SaveWorkspacePermissionRequestSchema = z.object({
    allowedPaths: z.array(z.string()),
    allowedStacks: z.array(z.string()),
    gitAuthorName: z.string(),
    role: WorkspacePermissionRoleSchema,
});
/** 権限の失効レスポンス。 @graph-connects none */
export const RevokeWorkspacePermissionResponseSchema = z.object({
    revoked: z.boolean(),
});
/** 管理者一覧の保存リクエスト。 @graph-connects none */
export const SaveWorkspacePermissionAdminsRequestSchema = z.object({
    admins: z.array(z.string()),
});
/** 管理者一覧レスポンス。 @graph-connects none */
export const WorkspacePermissionAdminsSchema = z.object({
    admins: z.array(z.string()),
    bootstrapAdmins: z.array(z.string()),
});
/** 権限の登録・更新の oRPC 入力（email を本文に含める）。 @graph-connects none */
export const UpsertWorkspacePermissionInputSchema = SaveWorkspacePermissionRequestSchema.extend({
    email: z.string(),
});
/** email だけを受ける oRPC 入力（失効）。 @graph-connects none */
export const WorkspacePermissionEmailInputSchema = z.object({
    email: z.string(),
});
//# sourceMappingURL=workspace-permissions.js.map